export default __webpack_public_path__ + "static/media/AIG.b2eaf6b4.svg";